import type { ReactElement } from 'react';
import { reasonTextRu } from '../domain/reason-codes';

export interface ReasonTextProps {
  readonly code: string;
}

/**
 * Renders a decision reason.
 *
 * The bare identifier (`RULE_OVERBOUGHT`, `SKIP_IMPULSE_COOLDOWN`, …) is never
 * put in the DOM — not as text, not as a tooltip. An operator reads Russian
 * prose; the identifier belongs in the CSV export and the audit trail.
 */
export function ReasonText({ code }: ReasonTextProps): ReactElement {
  return <span className="reason-text">{reasonTextRu(code)}</span>;
}
